import { OnInit, AfterViewInit } from '@angular/core';
import { AlertService } from '../exa/_services/alert.service';
import { AppInjector } from '../_helpers/app-injector';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import { Utils } from '../utils';
import { RoutingParameterService } from '../_services/routing-parameters.service';
import { UserContext } from '../_models/user-context';
import { HttpErrorResponse } from '@angular/common/http';
import { ViewChildren, QueryList } from '@angular/core';
import { ExaControlStato, ExaFormControl } from '../exa/exa-form-control';
import { ExaEmbed } from './exa-embed.interface';
import { DataContext } from '../_models/data-context';
import { LottoProduzione_Stato } from '../_models/lotto-produzione';
import { LottoSpedizione_Stato } from '../_models/lotto-spedizione';

declare var $: any;

export abstract class ComponentBase implements OnInit, AfterViewInit {
	@ViewChildren('exaControl') exacontrols: QueryList<ExaFormControl>;
	@ViewChildren('embedChild') embedChild: QueryList<ExaEmbed>;

	alertService: AlertService;
	infoOpened: string[];

	initJQuery: boolean = false;

	exaForm: FormGroup;
	isLoading: boolean = true;
	isSaving: boolean = false;
	protected routingParameterService: RoutingParameterService;

	initializationTerminated: boolean = false;

	componentName = "";

	/** Metodi comuni a tutti i componenti **/

	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		protected location: Location
	) {

		this.routingParameterService = AppInjector.get(RoutingParameterService);

		this.infoOpened = [];
		this.alertService = AppInjector.get(AlertService);
		this.exaForm = new FormGroup({});

		this.componentName = this.getComponentName();
	}

	getComponentName() {
		return "";
	}

	ngAfterViewInit() {
		$("[data-toggle=popover]").popover({
			html: true,
			content: function () {
				return $('#popover-content').html();
			}
		});
	}

	ngOnInit(): void {
		if (this.routingParameterService.parameters != null) {
			this.gestioneRoutingParameter(this.routingParameterService.parameters);
			this.routingParameterService.clear();
		}
		this.initializationTerminated = false;

		let dtx = Utils.getDataContext();
		this.startupTerminated();
	}
	abstract onInit(): void;


	startupTerminated() {
		this.initializationTerminated = true;

		this.onInit();
	}

	isInitializationTerminated() {
		return this.initializationTerminated;
	}


	getHomepageRoute(): string {
		return '/';
	}

	gestioneRoutingParameter(parameters: any): any {
		throw new Error("Method not implemented.");
	}

	toggleInfo(infoName: string) {
		let idx = this.infoOpened.indexOf(infoName);
		if (idx >= 0) {
			// Il pannello informazioni è aperto, lo tolgo
			this.infoOpened.splice(idx, 1);
		} else {
			this.infoOpened.push(infoName);
		}
	}

	openInfo(infoName: string) {
		let idx = this.infoOpened.indexOf(infoName);
		if (idx >= 0) return;

		this.infoOpened.push(infoName);
	}

	closeInfo(infoName: string) {
		let idx = this.infoOpened.indexOf(infoName);
		if (idx < 0) return;

		this.infoOpened.splice(idx, 1);
	}

	isInfoOpened(infoName: string): boolean {
		return this.infoOpened.indexOf(infoName) >= 0;
	}

	isControlNotValid(ctrl): boolean {
		return ctrl.status != 'VALID' && ctrl.touched && ctrl.errors;
	}

	toLog(o): boolean {
		console.log(o);
		return true;
	}


	abstract submit();

	formStatusChanges: any = null;


	// Se la callback non è definita chiamo il metodo submit()
	onSubmit(eForm, callback = null) {
		this.waitAllControls().first().subscribe(any => {
			this.onSubmitEffettivo(eForm, callback);
		});

	}

	onSubmitEffettivo(eForm, submit_callback = null) {
		this.alertService.clear();

		if (eForm == null)
			return;

		if (+this.getStatoPeggioreControlliExacoding() != ExaControlStato.ok) {
			return;
		}

		//verifica che tutti i controlli exa registrati siano in stato ready
		/*
		for (let i = 0; i < this.exacontrols.length; i++) {
			let exacontrol:ExaNoteComponent=this.exacontrols[i];
			console.log("a-"+exacontrol.ok);
		}
		*/
		if (submit_callback) {
			// associo il contesto alla callback altrimenti la chiamata dà errore
			submit_callback = submit_callback.bind(this);
		}

		this.validateAllFormFields(eForm);
		if (eForm.valid) {
			if (!submit_callback)
				this.submit();
			else
				submit_callback();
		} else {
			if (eForm.invalid) {
				this.alertService.error('Impossibile continuare. Verificare i dati.', 'errorVld');
				return;
			}

			// Se il form è in PENDING vuol dire che ci sono dei validatori 
			// asincroni che non hanno ancora terminato.
			if (eForm.pending && !this.formStatusChanges) {

				// 'Osservo' il cambio stato del form
				this.formStatusChanges = eForm.statusChanges.subscribe(
					data => {
						if (data != 'PENDING') {
							this.formStatusChanges.unsubscribe();
							this.formStatusChanges = null;

							if (data == 'VALID') {
								if (!submit_callback)
									this.submit();
								else
									submit_callback();
							} else if (data == 'INVALID' || data == 'DISABLED') {
								// non faccio niente
							}
						}
					}
				);
			}

			// Può arrivare qui se lo stato passa da pending a valid dopo il primo controllo?
			else if (eForm.valid) {
				if (!submit_callback)
					this.submit();
				else
					submit_callback();
			}
		}
	}

	validateAllFormFields(formGroup: FormGroup) {
		if (formGroup == null) return;
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field);
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateAllFormFields(control);
			} else if (control instanceof FormArray) {
				this.validateFormArray(control);
			}
		});
	}

	validateFormArray(formArray: FormArray) {
		formArray.controls.forEach(control => {
			if (control instanceof FormControl) {
				control.markAsTouched({ onlySelf: true });
			} else if (control instanceof FormGroup) {
				this.validateAllFormFields(control);
			} else if (control instanceof FormArray) {
				this.validateFormArray(control);
			}
		});
	}

	closeModal(selector: string) {
		$('#' + selector).modal('hide');
	}

	openModal(selector: string) {
		$('#' + selector).modal('show');
	}

	closePopup(selector: string) {
		$('#' + selector).popover('hide');
	}

	openPopup(selector: string) {
		$('#' + selector).popover('show');
	}

	scrollTo(selector: string, offset = 0) {
		let obj = $('#' + selector);

		if (obj != null && obj.length == 1)
			window.scroll({
				top: obj.offset().top - (70 + offset),
				left: 0,
				behavior: 'smooth'
			});

		/*	
		 * Su Safari 11.0.2 non funziona
	document.querySelector('#' + selector).scrollIntoView({ 
		behavior: 'smooth' 
	});
	*/
	}

	scrollToTop() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});

		/*	
		 * Su Safari 11.0.2 non funziona
	document.querySelector('#' + selector).scrollIntoView({ 
		behavior: 'smooth' 
	});
	*/
	}

	getStyleClass(id: number) {
		let mod = ((id - 1) % 5) + 1;
		switch (mod) {
			case 1:
				return 'primary';
			case 2:
				return 'secondary';
			case 3:
				return 'info';
			case 4:
				return 'warning';
			case 5:
				return 'light';
			default:
				return 'dark';
		}
	}

	getStyleClassStatoLottoProduzione(statoLottoProduzione: number){
		switch (statoLottoProduzione) {
			case LottoProduzione_Stato.Ordinato:
				return 'secondary';
			case LottoProduzione_Stato.DaProdurre:
				return 'primary';
			case LottoProduzione_Stato.Caricato:
				return 'secondary';
			case LottoProduzione_Stato.Prodotto:
				return 'secondary';
			case LottoProduzione_Stato.ErroreProduzione:
				return 'warning';
			case LottoProduzione_Stato.NotificatoProdotto:
				return 'info';
			case LottoProduzione_Stato.Spedito:
				return 'success';
			default:
				return 'secondary';
		}
	}

	getStyleClassStatoLottoSpedizione(statoLottoSpedizione: number){
		switch (statoLottoSpedizione) {
			case LottoSpedizione_Stato.Richiesto:
				return 'secondary';
			case LottoSpedizione_Stato.DaComporre:
				return 'primary';
			case LottoSpedizione_Stato.DaEvadere:
				return 'primary';
			case LottoSpedizione_Stato.Spedito:
				return 'secondary';
			case LottoSpedizione_Stato.NotificaSpedito:
				return 'primary';
			case LottoSpedizione_Stato.Consegnato:
				return 'secondary';
			case LottoSpedizione_Stato.NonConsegnato:
				return 'secondary';
			case LottoSpedizione_Stato.NotificaConsegnato:
				return 'success';
			case LottoSpedizione_Stato.NotificaNonConsegnato:
				return 'danger';
			case LottoSpedizione_Stato.DaRispedire:
				return 'primary';
			default:
				return 'secondary';
		}
	}

	getStyleClassDispositivo(tipoDispositivo: string) {
		switch (tipoDispositivo) {
			case 'Smartcard':
				return 'primary';
			case 'Token Display':
				return 'secondary';
			case 'Token Yukido':
				return 'info';
			default:
				return 'dark';
		}
	}	

	removeIndeterminate(fc: FormControl, defaultValue = true) {
		if (fc.value == null) fc.setValue(defaultValue);
	}


	//deve essere sovrascritto se i subpath possono essere di più o dinamici
	getSubPathLength(): number {
		return 2;
	}

	getParentPath(): string {
		let ret: string = "";
		for (let i = 0; i < this.getSubPathLength(); i++) {
			ret = ret + "../";
		}
		return ret;
	}

	goBack(): void {
		this.router.navigate([this.getParentPath()], { queryParams: this.getQueryParams(), relativeTo: this.route });
	}

	getQueryParams() {
		return {};
	}


	setRoutingParameter(parameters: any) {
		this.routingParameterService.parameters = parameters;
	}

	handleError(err: any, customError500Msg = '') {
		if (err instanceof HttpErrorResponse) {
			this.alertService.error(this.getHttpErrorMessage(err, customError500Msg), 'error' + err.status);
		}
		else {
			this.alertService.error('Impossibile continuare')
			console.error(err);
		}
	}

	getHttpErrorMessage(err: HttpErrorResponse, customError500Msg = '') {
		console.log('status: ' + err.status)
		let msg = "";
		switch (err.status) {
			case 400: // 400
				msg = 'Errore di validazione';
				console.error(err);
				break;
			case 401: // UNAUTHORIZED
				msg = 'Operazione non permessa';
				break;
			case 403: // FORBIDDEN
				msg = 'Operazione non permessa';
				break;
			case 404: // NOT FOUND
				msg = 'Elemento inesistente';
				break;
			case 409: // CONFLICT
				msg = 'Si è verificato un conflitto';
				break;
			case 413: // PAYLOAD TOO LARGE
				msg = 'Impossibile caricare il file: dimensione eccessiva';
				break;
			case 415: // UNSUPPORTED MEDIA FILE
				msg = 'Tipo di file non valido';
				break;
			case 500: // Internal server error
				if (customError500Msg != '')
					msg = customError500Msg;
				else
					msg = 'Internal server error';
				console.error(err);
				break;
			default:
				msg = 'Servizio non disponibile';
				console.error(err);
		}

		return msg;
	}

	recalculateCurrentPage(): void {
		this.routingParameterService.parameters = { urlToReturn: this.router.url };
		this.router.navigate(['/waiting']);
	}

	waitAllControls(delay: number = 100): Observable<void> {
		return new Observable((observer) => {
			let interval = setInterval(() => {
				if (this.getStatoPeggioreControlliExacoding() != ExaControlStato.wait) {
					observer.next();
					observer.complete();
					clearInterval(interval);
				}
			}, 100);
			// observable execution
		})

	}

	isUtenteAmministratore() {
		return Utils.isUtenteAmministratore();
	}

	isUtenteRichiedente() {
		return Utils.isUtenteRichiedente();
	}

	isModifichePermesse() {
		return !Utils.isUtenteAmministratore();
	}

	getStatoPeggioreControlliExacoding(): ExaControlStato {
		let statoPeggioreControlli: ExaControlStato = ExaControlStato.ok;
		this.exacontrols.forEach(exacontrol => {
			if (exacontrol.stato == ExaControlStato.error) {
				statoPeggioreControlli = ExaControlStato.error;
			} else {
				if (exacontrol.stato == ExaControlStato.wait && +statoPeggioreControlli == ExaControlStato.ok) {
					statoPeggioreControlli = ExaControlStato.wait;
				}

			}
		});

		return statoPeggioreControlli;
	}

	resetExaEmbedChildren() {
		if (this.embedChild) {
			this.embedChild.forEach(ch => {
				if (ch.canReset())
					ch.reset();
			});
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/component-base.component.ts